function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuotesMark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 46,
    viewBox: "0 0 60 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M585.625,171.053485 L595,171.053485 L595,196 L570,196 L570,177.121556 C570,156.501248 578.33325,145.460839 595,144 L595,153.354943 C588.749969,155.096713 585.625,160.097203 585.625,168.356564 L585.625,171.053485 Z M620.625,171.053485 L630,171.053485 L630,196 L605,196 L605,177.121556 C605,156.501248 613.33325,145.460839 630,144 L630,153.354943 C623.749969,155.096713 620.625,160.097203 620.625,168.356564 L620.625,171.053485 Z",
    opacity: 0.2,
    transform: "translate(-570 -144)",
    style: {
      mixBlendMode: "multiply"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotesMark);
export default __webpack_public_path__ + "assets/media/quotes_mark.d8cfaacc8845b57eb8c03e7b5ef71bfe.svg";
export { ForwardRef as ReactComponent };